import { gql } from '@apollo/client';

export const PROPOSAL_DOCUMENT_FIELDS = gql`
  fragment ProposalDocumentFields on ProposalDocument {
    id
    simulationId
    simulationType
    kind
    status
    gdProposalId
    downloadUrl
    downloadUrls
    error
    createdAt
    finishedAt
  }
`;

export const PROPOSAL_DOCUMENT_QUERY = gql`
  ${PROPOSAL_DOCUMENT_FIELDS}
  query ProposalDocument($id: ID!) {
    proposalDocument(id: $id) {
      ...ProposalDocumentFields
    }
  }
`;
